export const PROFESSIONAL_KITCHEN_EQUIPMENT_STOVE = "STOVE";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_OVEN = "OVEN";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_WORKPLAN = "WORKPLAN";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_MICROWAVES = "MICROWAVES";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_SINK_DISHWASHER = "SINK_DISHWASHER";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_COOKING_TOOLS = "COOKING_TOOLS";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_DRY_STORAGE_SPACE = "DRY_STORAGE_SPACE";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_FRIDGE = "FRIDGE";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_COLD_ROOM = "COLD_ROOM";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_FREEZER = "FREEZER";
export const PROFESSIONAL_KITCHEN_EQUIPMENT_OTHER = "OTHER";
